import React from 'react';
import { Briefcase } from 'lucide-react';
import { JOB_SOURCES } from '../../../constants/jobSources.js';

export default function SourcesSection({ filters, onChange, onClear }) {
    const anyDisabled = JOB_SOURCES.some((src) => filters.sources?.[src.id] === false);
    return (
        <div className="bg-white p-4 rounded-xl border border-gray-100 h-fit">
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2 font-semibold text-gray-700">
                    <Briefcase size={20} className="text-gray-400" />
                    <span>Sources</span>
                </div>
                {anyDisabled && (
                    <button
                        type="button"
                        onClick={onClear}
                        className="text-xs font-medium text-gray-400 hover:text-red-600 focus:outline-none transition-colors"
                    >
                        Clear
                    </button>
                )}
            </div>
            <div className="space-y-2">
                {JOB_SOURCES.map((src) => {
                    const checked = filters.sources?.[src.id] !== false;
                    return (
                        <label
                            key={src.id}
                            className="flex items-center gap-2 cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => onChange({
                                    ...filters,
                                    sources: { ...filters.sources, [src.id]: e.target.checked }
                                })}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm text-gray-700">{src.label}</span>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}
